export default __webpack_public_path__ + "media/c825c91a9fc29dfd7e41f2a7d0d35eaf0bc304e8fe5c3b5af56bdaf3b82042b3.svg";